import $ from 'jquery';
import _ from 'lodash';
import isMobile from '@/lib/navigation-is-mobile.js';
import OpenRounds from '@/lib/open-rounds.js';
import Preferences from '@/modules/top-pick/Preferences/Preferences.vue';
import ProgressBar from '@/modules/top-pick/PicksProgressBar.vue';
import ScoreSetSelector from '@/lib/components/Selectors/ScoreSetSelector.vue';
import stickybits from 'stickybits';
import store from '@/lib/store/index.js';
import ToggleSwitch from '@/lib/components/Shared/ToggleSwitch.vue';
import Vue from 'vue';

export default function () {
	store.commit('topPick/resetState');

	$(document).one('pjax:start', () => {
		store.commit('topPick/resetState');
	});

	if ($('#toggle-my-picks-only').length) {
		new Vue({
			el: '#toggle-my-picks-only',
			name: 'TopPickToggleApp',
			components: {
				'toggle-switch': ToggleSwitch,
			},
		});
	}

	if ($('#picks-progress-bar').length) {
		new Vue({
			el: '#picks-progress-bar',
			name: 'TopPickProgressBarApp',
			components: {
				'picks-progress-bar': ProgressBar,
			},
			store,
		});
	}

	new Vue({
		el: '#scoreSetSelector',
		components: {
			'score-set-selector': ScoreSetSelector,
		},
		store,
	});

	const rows = document.querySelectorAll('.preferences');

	[].forEach.call(rows, (el) => {
		new Vue({
			el: el,
			name: 'TopPickPreferencesApp',
			components: {
				preferences: Preferences,
			},
			store,
		});
	});

	new OpenRounds();

	// Filtertron
	$('.filtertron').filtertron('entries', {
		expander: '#filtertronExpander',
	});

	if (!isMobile()) {
		stickybits('.header-controls', { useStickyClasses: true });

		const scrollHandler = _.debounce(function () {
			// Header became sticky
			if ($('.header-controls').hasClass('js-is-sticky')) {
				$('#quick-selector-category').addClass('closed');
			}

			// Top of the browser window reached
			if ($(window).scrollTop() === 0 && $('#quick-selector-category').hasClass('open')) {
				$('#quick-selector-category').removeClass('closed');
			}
		}, 100);

		// Collapse category selector when it becomes sticky to save vertical space
		$(window).on('scroll', scrollHandler);

		$(document).one('pjax:end', () => {
			$(window).off('scroll', scrollHandler);
		});
	}
}
